import BrandInput from "@/widgets/Inputs/BrandInput.vue";
import SeasonInput from "@/widgets/Inputs/SeasonInput.vue";
import Hispickup from "@/widgets/Hispickup.vue";
import EnumFilter from "@/components/Fields/EnumFilter.vue";

export default {
	data() {
		return {
			filterTableSearch: "",
			filterBrand: {
				name: "",
				_id: ""
			},
			filterHisDate: null,
			baseKv: [],
			kvFilter: {}
		};
	},
	computed: {
		// kvFilter() {
		// 	let baseKv = [];
		// 	this.baseKv.forEach(val => {
		// 		baseKv.push(Object.assign({}, val));
		// 	});
		// 	if (this.filterPluses.length > 0) {
		// 		this.filterPluses.forEach(val => {
		// 			baseKv.push(Object.assign({}, val));
		// 		});
		// 	}
		// 	if (this.filterClassify.length > 0) {
		// 		baseKv.push({ k: "classify._id", t: "id", v: this.filterClassify[this.filterClassify.length - 1]._id });
		// 	}
		// 	if (this.filterBrand._id !== "") {
		// 		baseKv.push({ k: "brand", t: "id", v: this.filterBrand._id });
		// 	}
		// 	if (this.filterColor._id !== "") {
		// 		baseKv.push({ k: "color", t: "id", v: this.filterColor._id });
		// 	}
		// 	if (this.filterModel._id !== "") {
		// 		baseKv.push({ k: "model", t: "id", v: this.filterModel._id });
		// 	}
		// 	if (this.filterCustomer._id !== "") {
		// 		baseKv.push({ k: "customer", t: "id", v: this.filterCustomer._id });
		// 	}
		// 	if (this.filterSaler._id !== "") {
		// 		baseKv.push({ k: "saler", t: "id", v: this.filterSaler._id });
		// 	}
		// 	if (this.filterSupplier._id !== "") {
		// 		baseKv.push({ k: "supplier", t: "id", v: this.filterSupplier._id });
		// 	}
		// 	if (this.filterSeason._id !== "") {
		// 		baseKv.push({ k: "season", t: "id", v: this.filterSeason._id });
		// 	}
		// 	if (this.filterWarehouse._id !== "") {
		// 		baseKv.push({ k: "warehouse", t: "id", v: this.filterWarehouse._id });
		// 	}
		// 	if (this.filterProduct._id !== "") {
		// 		baseKv.push({ k: "product_color", t: "id", v: this.filterProduct._id });
		// 	}
		// 	this.filterEnums.forEach(val => {
		// 		if (val.index != null && val.index !== "") {
		// 			baseKv.push({ k: val.field, t: "int", v: val.index });
		// 		}
		// 	});
		// 	this.filterBools.forEach(val => {
		// 		if (val.value != null && val.value !== "") {
		// 			baseKv.push({ k: val.field, t: "int", v: val.value });
		// 		}
		// 	});
		// 	return baseKv;
		// }
	},
	watch: {
		baseKv: {
			handler(vals) {
				vals.forEach(val => {
					if (val !== "") {
						this.$set(this.kvFilter, val.k, val);
					} else {
						this.$delete(this.kvFilter, val.k);
					}
				});
			},
			immediate: true
		},
		"filterBrand._id": {
			handler(val) {
				let fieldName = "brand";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		},
	},
	methods: {
		resetTable(table) {
			if (table == "listTable") {
				this.filterAgentName = "";
			} else {
				this.filterHisDate = null;
			}
			this.$nextTick(() => {
				this.refreshTable(table);
			});
		}
	},
	components: {
		Hispickup,
		BrandInput,
		EnumFilter
	}
};
